
import React, { useState , useContext, useEffect} from 'react';
import { UserContext } from '../UserContext';
import { useNavigate , useParams, Link} from 'react-router-dom';
import { Button, Card , Form , Row , Col} from 'react-bootstrap';
import logo from '../assets/logo_rushters_negro.png';
import Image from 'react-bootstrap/Image';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import secureLocalStorage  from  "react-secure-storage";

const Login = () => {
    const navigate= useNavigate();
    const {benefitId} = useParams();
    const [validated, setValidated] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { login,setBenefitId , user, isLoggedIn, logout} = useContext(UserContext);

    if(user){
        const m = secureLocalStorage.getItem("activeModule");
        if(m){
            if(m === "2") navigate(`/register`);
            if(m === "1") navigate(`/admin`);
        }
        else{
            navigate(`/register`);
        }
    }

    useEffect( () => {
        if(typeof benefitId !== 'undefined' ){
            setBenefitId(benefitId);
        }

    },[user]);

    const signIn = (event) =>  {
        event.preventDefault();
        event.stopPropagation();
        setValidated(true);
        const userInstance = login(email,password);
        if(userInstance=== null ){
            const m = secureLocalStorage.getItem("activeModule");
            if(m){
                if(m === "2") navigate(`/register`);
                if(m === "1") navigate(`/admin`);
            }
            else{
                navigate(`/register`);
            }

        }
    }

    return (
        <>
        <Navbar bg="dark"  expand="lg" className="bg-body-tertiary" data-bs-theme="dark">
            <Container fluid>
            </Container>
        </Navbar>
        <Container>
            <Row>
                <Col xs={1} md={2} lg={3} ></Col>
                <Col xs={10} md={8} lg={6}>
                <div className='pt-5'>
                        <Card className="text-center " >
                            <Card.Header className='titleDefault' >
                                <Image fluid src={logo} width={200} height={40}/>
                            </Card.Header>
                            <Card.Body>
                                <Card.Title className='titleDefault pb-2'></Card.Title>
                                <Form  validated={validated} onSubmit={signIn}>
                                    <Form.Group as={Row} className="mb-3" controlId="formPlaintextEmail">
                                        <Form.Label column sm="3">

                                        </Form.Label>
                                        <Col sm="6">
                                        <Form.Control
                                        type="email"
                                        placeholder="Email"
                                        onChange={(event) => setEmail(event.currentTarget.value)}
                                        value={email}
                                        required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            Ingresa un email
                                        </Form.Control.Feedback>
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword">
                                        <Form.Label column sm="3">

                                        </Form.Label>
                                        <Col sm="6">
                                        <Form.Control
                                            type="password"
                                            placeholder="Clave de acceso partners"
                                            aria-label="Clave de acceso patners"
                                            onChange={(event) => setPassword(event.currentTarget.value)}
                                            value={password}
                                            required
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            El campo Clave es requerida
                                        </Form.Control.Feedback>

                                        </Col>
                                    </Form.Group>
                                    <Button  className='mt-3 mb-3 btn btn-sm btn-block btn-danger' type='submit' >
                                        Iniciar sesión
                                    </Button>
                                </Form>
                                <br />
                                <Link to='/forgot-password'>¿Olvidaste tu contreseña?</Link>

                            </Card.Body>
                        </Card>

                </div>
                </Col>
                <Col xs={1} md={2} lg={3}></Col>

            </Row>
        </Container>

        </>

    );
};

export default Login;